import { useEffect } from "react";
import { useTranslations, t } from "~/translations/utils";

export function UnauthorizedRequestModal({ open, toggleOpen }) {
  useTranslations();

  useEffect(() => {
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        toggleOpen(false);
      }
    });
  });

  return (
    <div
      id="unauthorized-request-modal"
      className={`modal ${open ? "is-active" : ""}`}
    >
      <div
        className="modal-background"
        onClick={() => toggleOpen(false)}
        tabIndex="0"
      ></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">
            {t("landing.unauthorizedRequestModal.title")}
          </p>
          <button
            className="delete"
            aria-label="close"
            onClick={() => toggleOpen(false)}
          ></button>
        </header>
        <section className="modal-card-body">
          {t("landing.unauthorizedRequestModal.description")}
        </section>
        <footer className="modal-card-foot">
          <div className="buttons">
            <button className="button" onClick={() => toggleOpen(false)}>
              {t("landing.unauthorizedRequestModal.close")}
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
}
